import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import Tabs from "./tabs_report";
import Search from "./search_report";
import DashboardFilter from '../../dashboard/filter';
import { WrapperForm } from "./styles";
import { setReportesFilters } from '../../../store/fuse/reportes';
import FilterReport from './filter_report';

const Index = (props) => {
  const [inmueble, setInmueble] = useState('');
  const [region, setRegion] = useState('');
  const [grupo, setGrupo] = useState('');

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const fetchAllData = () => {};

  return (
    <>
      <Grid container spacing={2} sx={{ marginBottom: '10px' }}>
        {/* <Grid item lg={12} md={12} sm={12} xs={12}>
          <DashboardFilter
            currentFilters={{ inmueble, region, grupo, dateInit, dateEnd }}
            filtersSetters={{ setInmueble, setRegion, setGrupo, setDateInit, setDateEnd }}
            setFilters={setReportesFilters}
            fetchAllData={fetchAllData}
            view="node-details"
          />
        </Grid> */}
      </Grid>
      <WrapperForm>
        <div
          className="w-full justify-around m-10 rounded-lg mt-0 p-20"
          style={{ backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white', display: 'flex', flexDirection: 'column' }}
        >
          <div className="w-full">
            <Search />
          </div>
          <div className="w-full">
            <FilterReport {...props} />
          </div>
        </div>
      </WrapperForm>
    </>
  );
};

export default Index;

